import { client, type ClientId } from '@atlassian/rovo-content-bridge-api/client-types';

export const JIRA_SMART_CREATE_MODAL_CLIENT_ID: ClientId = client('jira-smart-create-modal');

export const JIRA_SMART_CREATE_TABLE_CLIENT_ID: ClientId = client('jira-smart-create-table');

export const JIRA_PREVIEW_CARD_CLIENT_ID: ClientId = client('jira-preview-card');
